import { Component, inject } from '@angular/core';


import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { AuthService } from '../shared/auth/auth.service';
import { combineLatest } from 'rxjs';
import { LoaderComponent } from '../loader/loader.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-authcallack',
  imports: [],
  templateUrl: './authcallack.component.html',
  styleUrl: './authcallack.component.scss'
})
export class AuthcallackComponent {
  user: any = null;
  auth0Service = inject(Auth0Service);
  auth = inject(AuthService);
  dialog = inject(MatDialog)
  router = inject(Router);
  ngOnInit() {
    // Fhir.oauth2.ready({

    // }).then((client: Client) => {
    //   console.log(client);
    //   client.create({
    //     resourceType: 'Patient',
    //     name: [{ given: ['John'], family: 'Doe' }],
    //     gender: 'male',
    //     birthDate: '1980-01-01'
    //   }).then((metadata) => {
    //     console.log('Fetched metadata:', metadata);
    //   });
    //   let user = client.getFhirUser();

    //   console.log('FHIR User:', user);
    //   if (user) {
    //     // i wanna know the user details - if it's practitioner go to prac
    //     // if it's patient - go to patient ;
    //     let userType = user.split("/")[0];
    //     let userId = user.split("/")[1];
    //     client.request(`/${userType}/${userId}`).then((userDetails) => {
    //       this.user = userDetails;
    //     });
    //   }
    // })


    combineLatest([
      this.auth0Service.isLoading$,
      this.auth0Service.isAuthenticated$,
      this.auth0Service.user$,


    ]).subscribe(([isLoading, isAuthenticated, user]) => {
      let dref: MatDialogRef<LoaderComponent> | undefined;

      if (isLoading) {
        dref = this.dialog.open(LoaderComponent);
      } else {
        if (dref) {
          dref.close();
        }
        if (isAuthenticated && user) {
          const target = "/app/dashboard"
          const current = this.auth?.user?.getValue();
          if (!current || current.role !== 'cashier') {
            // Ensure login redirects to our target route
            this.auth.triedUrl = target;
            this.auth.login('cashier123', 'cashier123');
          } else {
            // Already a cashier: navigate directly
            this.router.navigateByUrl(target);
          }
        } else {
          this.auth0Service.loginWithRedirect();
        }
      }

      // this.auth0Service.loginWithRedirect();



    });
  }


}
